
export default function(context) {
	const ajaxLoad = context.querySelectorAll('[data-load]');
	[...ajaxLoad].forEach((item) => {
		item.addEventListener('click', (event) => {
			event.preventDefault();

			const { currentTarget } = event;
			const url = currentTarget.getAttribute('data-load');
			const title = currentTarget.getAttribute('data-title'); // || currentTarget.innerText;
			const method = currentTarget.getAttribute('data-load-method') || 'POST';
			const target = currentTarget.getAttribute('data-target') || '_blank';

			const modal = Modal.load(url, {
				title,
				method,
				target
			},
			{
				backurl: location.href.replace(location.origin, ''),
			});

			modal.subscribe(Modal.Events.HIDDEN, () => {
				modal.dispose();
			});

			if (target != '_self')
			{
				modal.subscribe(Modal.Events.AFTER_INSERTED, ({ data: { instance } }) => {
					app.init(instance.body);
				});
			}
		});
	});
}
